
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Results</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Results</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
       
        <div class="row">
          <div class="col-12">
            <div class="card card-outline card-danger">
           
              <div class="card-body" >
                <div class="row"> <div class="col-md-3">

                    <label class="form-label">Select Semester
                    </label>
                    <select class="form-control"  name="clid1" [(ngModel)]="clid" #clid1="ngModel"
                      (change)="getfees()">
                      <option [ngValue]="k.clid" *ngFor="let k of arrclass">
                        {{k.clnm}}
                      </option>
      
                    </select>
                  </div></div>
                <table role="table" class="table table-hover">
                    <thead role="rowgroup">
                      <tr role="row" >
                        <th role="columnheader" rowspan="2">Sl No.</th>
                      
                        <th role="columnheader"  rowspan="2">Course</th>
                        
                        <th role="columnheader" colspan="2">Theory/Practical Marks</th>
                        <th role="columnheader" colspan="2">CIA Marks</th>
                        <th role="columnheader" colspan="2">Total Marks</th>
                       
                    
                     
                        <th role="columnheader" rowspan="2">Grade Points</th>
                        <th role="columnheader" rowspan="2">Credit Assigned</th>
                        <th role="columnheader" rowspan="2">Credit Points</th>
                        <th role="columnheader" rowspan="2">Remarks</th>
                      
                      </tr>

                      <tr role="row" >
                        
                        <th role="columnheader">Max.</th>
                        <th role="columnheader">Sec.</th>

                        <th role="columnheader">Max.</th>
                        <th role="columnheader">Sec.</th>

                        <th role="columnheader">Max.</th>
                        <th role="columnheader">Sec.</th>

                       
                      
                      </tr>
                    </thead>
                    <tbody role="rowgroup" *ngFor="let fee of feedtls;let i = index">
                      <tr role="row">
                        <td role="cell">{{i+1}}</td>
                    
                        <td role="cell">{{fee.sucd}}-{{fee.sunm}}</td>
                        <td role="cell">{{fee.maxese}}</td>
                        <td role="cell">{{fee.scese}}</td>
                        <td role="cell">{{fee.maxcia}}</td>
                        <td role="cell">{{fee.sccia}}</td>
                        <td role="cell">{{fee.maxsc}}</td>
                        <td role="cell">{{fee.totalsc}}</td>
                        <td role="cell">{{fee.gradepts}}</td>
                        <td role="cell">{{fee.creditsas}}</td>
                        <td role="cell">{{fee.creditpts}}</td>
                        <td role="cell">{{fee.result}}</td>
                        
                        
                      
                    
                       
                     
                     
                      </tr>
                   
                   
                    </tbody>
                    <tr><td colspan="2"><span style="font-weight:bold">GRAND TOTAL</span></td><td colspan="4"></td><td ><span style="font-weight:bold">{{feesum.maxsc}} </span></td><td ><span style="font-weight:bold">{{feesum.totalsc}} </span></td><td></td><td ><span style="font-weight:bold">{{feesum.creditsas}}</span></td><td ><span style="font-weight:bold">{{feesum.creditpts}}</span></td></tr>
                    <tr><td colspan="5"><b>Total in words: {{feesum.inwords}}</b></td><td colspan="3"><b>SGPA: {{feesum.sgpa}}</b></td><td colspan="4"><b>GRADE: {{feesum.semgr}}</b></td></tr>
                  </table>


              </div>


             
              <!-- /.col -->
   


              



              <!-- /.card-body -->
            </div>
           
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
 
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->


